import { Injectable } from "@angular/core";
import { Angular5Csv } from "angular5-csv/dist/Angular5-csv";

@Injectable()
export class ExportToCSVService {
  options: any;

  constructor() {
    this.options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalseparator: ".",
      showLabels: false,
      showTitle: false,
      useBom: true
    };
  }

  generateCSV(data: any[]) {
    this.options.headers = [
      "ACCOMMS PIN",
      "FIRST NAME",
      "LAST NAME",
      "MIDDLE NAME",
      "APPROVED ACCOMMODATIONS",
      "NOT APPROVED ACCOMMODATIONS",
      "IN REVIEW ACCOMMODATIONS",
      "INCOMPLETE ACCOMMODATIONS",
      "ASSOCIATED TEST DATES"
    ];
    data.forEach(obj => {
      for (const i in obj) {
        if (obj.hasOwnProperty(i) && !obj[i]) {
          obj[i] = "";
        }
      }
    });
    const generator = new Angular5Csv(data, "ExamineeDetails", this.options);
  }
}



// WEBPACK FOOTER //
// ./client/views/services/exporttocsv.service.ts